import { render, staticRenderFns } from "./PartnersStats.vue?vue&type=template&id=37a55c8e"
import script from "./PartnersStats.vue?vue&type=script&lang=js"
export * from "./PartnersStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports